import { render, staticRenderFns } from "./LinkageLogList.vue?vue&type=template&id=c14870cc&scoped=true&"
import script from "./LinkageLogList.vue?vue&type=script&lang=js&"
export * from "./LinkageLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14870cc",
  null
  
)

export default component.exports